module.exports = __webpack_public_path__ + "img/detail-header-bg.7c7677f7.png";